<template>
  <div
    class="h-screen w-screen flex flex-col justify-center items-center bg-tl-grey-300 dark:bg-tl-grey-100"
  >
    <h1 class="text-3xl text-white">You are now registered as a user in TeamLearn</h1>
    <br />
    <p class="text-yellow-400 cursor-pointer" @click="login()">Login</p>
  </div>
</template>

<script setup lang="ts">
import router from '@/router'

function login() {
  router.push('/')
}
</script>
